export default __webpack_public_path__ + "static/media/heartlands.9ec3c0cd.jpg";